import { takeLatest, call, put } from 'redux-saga/effects';
import api from '../../api/index';
import {
  GET_USER_ONBOARDING, SET_USER_ONBOARDING, USER_ONBOARDING_REQUEST_FAILED, SENDING_USER_ONBOARDING_REQUEST,
} from '../../types/Types';

/**
 * Call the api and dispatch data to the reducer
 * @param { Object } action Contained object data to be send to API call
 */
export function* userOnBoarding(action) {
  const { data } = action;
  // console.log(data);
  try {
    yield put({
      type: SENDING_USER_ONBOARDING_REQUEST,
      userOnBoardingData: '',
      isOnBoardingSending: true,
      isOnBoardingSuccess: false,
      onBoardingError: false,
    });
    const response = yield call(api.users.onBoard, data);
    // console.log(response);
    if (response) {
      // console.log('inside');
      yield put({
        type: SET_USER_ONBOARDING,
        userOnBoardingData: response,
        isOnBoardingSending: false,
        onBoardingError: false,
        isOnBoardingSuccess: true,
      });
    } else {
      yield put({
        type: USER_ONBOARDING_REQUEST_FAILED,
        userOnBoardingData: null,
        isOnBoardingSending: false,
        onBoardingError: true,
        isOnBoardingSuccess: false,
        onBoardingMsg: response.errorMsg,
      });
    }
  } catch (e) {
    yield put({
      type: USER_ONBOARDING_REQUEST_FAILED,
      onBoardingMsg: e.message,
      isOnBoardingSending: false,
      onBoardingError: true,
      isOnBoardingSuccess: false,
      userOnBoardingData: null,
    });
  }
}

/**
 * map the dispatched action to the above function
 */
export default function* watchUserOnBoarding() {
  yield takeLatest(GET_USER_ONBOARDING, userOnBoarding);
}
